<template>
  <div class="margin-bottom">
    <el-table :data="pagingList"
              v-loading="loadingStatus"
              :header-cell-style="headerCellStyle"
              :span-method="spanMethod"
              class="custom-delivery-table"
              max-height="600px"
              size="mini"
              border>
      <el-table-column label="起运城市"
                       v-if="!isDeliveryType"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.cityNameText||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="分区"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.regionName||"-" }}
          <template v-if="scope.row.regionInfoText">
            ({{scope.row.regionInfoText}})
          </template>
        </template>
      </el-table-column>
      <el-table-column label="拆柜城市"
                       v-if="!isSegment || type === 1"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.dismantlingCityName || scope.row.dismantlingCityId || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="货物类型"
                       v-if="!isDeliveryType"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.goodsTypeList">
            <el-tooltip placement="top">
              <div slot="content" style="max-width: 800px;">{{ joinGoodsTypeText(scope.row.goodsTypeList) }}</div>
              <span style="text-overflow: ellipsis;-webkit-line-clamp: 3;-webkit-box-orient: vertical;display: -webkit-box;">
                {{ joinGoodsTypeText(scope.row.goodsTypeList) }}
              </span>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
      <template v-if="tableHeaderList.length">
        <template v-for="(item,index) in tableHeaderList">
          <el-table-column
            :label="joinLabelText(item,index)"
            :key="index"
            min-width="120"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.priceList && scope.row.priceList.length > index">
                <custom-price-column
                  :price-item="scope.row.priceList[index]"
                  :is-need-inquiry="scope.row.isNeedInquiry"
                  :exemption-type="scope.row.exemptionType"
                  :open-custom="openCustom"
                  @change="value => changePriceInput(value,scope.row)"
                  :copy-vip-price="copyVipPrice"
                />
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
      <el-table-column
        v-if="isShowRatioSetting"
        :label="tableHeaderList.length ? tableHeaderList[0].chargeType === 'KG' ? '体积重比率' : '体重比' : '体积重比率'"
        :prop="tableHeaderList.length ? tableHeaderList[0].chargeType === 'KG' ? 'volumeWeightRatio' : 'weightVolumeRatio' : 'volumeWeightRatio'"
        width="120"
        align="center">
      </el-table-column>
      <template v-if="!isSegment && type === 1">
        <el-table-column label="提取时效"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <div class=""
                 style="min-width: 90px;position: relative;z-index: 2">
              <el-link  @click="showSetTime(scope.$index,scope.row)"
                        v-if="scope.row.extractionAgingFrom && scope.row.extractionAgingTo && scope.row.extractionAgingUnit"
                        :disabled="copyVipPrice"
                        type="">
                {{scope.row.extractionAgingFrom}} - {{scope.row.extractionAgingTo}}
              </el-link>
              <el-link @click="showSetTime(scope.$index,scope.row)"
                       v-else
                       type="">设置
              </el-link>
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column :label="deliveryAgingLabel"
                       width="100"
                       align="center">
        <template slot-scope="scope">
          <div class=""
               style="min-width: 90px;position: relative;z-index: 2">
            <el-link  @click="showSetTime(scope.$index,scope.row)"
                      v-if="scope.row.agingFrom && scope.row.agingTo && scope.row.agingUnit"
                      :disabled="copyVipPrice"
                      type="">
              {{scope.row.agingFrom}} - {{scope.row.agingTo}}
            </el-link>
            <el-link @click="showSetTime(scope.$index,scope.row)"
                     v-else
                     type="">设置
            </el-link>
          </div>
        </template>
      </el-table-column>
      <template v-if="isSupportMultiChannel">
        <el-table-column label="专线api对接渠道代码"
                         width="90"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.channelCode||"-" }}
          </template>
        </el-table-column>
      </template>
      <el-table-column label="备注"
                       width="150"
                       align="center">
        <template slot-scope="scope">
          <!--:prop="'regionHeaderList['+scope.$index+'].remark'"-->
          <!--:rules="formRules.no"-->
          <el-form-item label="备注"
                        class="hide-label">
            <el-input v-model="scope.row.remark"
                      size="mini"
                      style="width: 120px"
                      class="edit-form__input4"
                      :disabled="copyVipPrice"
                      placeholder="请输入"></el-input>
          </el-form-item>
          <!--<el-link v-if="scope.row.remark"-->
          <!--type="primary">编辑</el-link>-->
          <!--<el-link v-else-->
          <!--type="danger">编辑</el-link>-->
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       v-if="openSetFreeDelivery"
                       min-width="120"
                       align="center">
        <template slot-scope="scope">
          <el-button
            @click="setFreeDelivery(scope.row,scope.row.exemptionType === 2 ? 1 : 2)"
            :type="scope.row.exemptionType === 2 ? '':'primary'"
            :disabled="scope.row.isNeedInquiry || copyVipPrice"
            plain
            size="mini">
            {{ scope.row.exemptionType === 2 ? "取消免派区域" : "设为免派区域"}}
          </el-button>
          <!--<el-link v-else-->
          <!--type="danger">编辑</el-link>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="list && list.length>pageSize"
      class="paging-row"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalListNum"
    >
    </el-pagination>

<!--    :width="!isSegment?'700px' : ( type === 1 ? '600px' : '400px' )"-->
    <el-dialog title="设置时效"
               width="700px"
               custom-class="product-quotation__edit-dialog"
               :visible.sync="visibleSetTime"
               :modal-append-to-body="true"
               :append-to-body="true"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <el-form :model="editFormTime"
               ref="editSetTime"
               label-width="100px"
               :inline="true"
               @submit.native.prevent>
        <template v-if="!isSegment && type === 1">
          <el-form-item label="提取时效"
                        prop="extractionAgingFrom"
                        :rules="formRulesFreightPrice.extractionAgingFrom">
            <div class="el-date-editor el-range-editor el-input__inner el-range-editor--small"
                 style="width: 160px;">
              <input class="el-range-input input-number__no-arrows"
                     v-model="editFormTime.extractionAgingFrom"
                     type="number"
                     placeholder="请输入"
                     autocomplete="off">
              <span class="el-range-separator">至</span>
              <input class="el-range-input input-number__no-arrows"
                     v-model="editFormTime.extractionAgingTo"
                     type="number"
                     placeholder="请输入"
                     autocomplete="off">
            </div>
          </el-form-item>
          <el-form-item label="提取时效单位"
                        label-width="0"
                        class="hide-label"
                        prop="extractionAgingUnit"
                        :rules="formRulesFreightPrice.agingUnit">
            <el-select v-model="editFormTime.extractionAgingUnit"
                       size="small"
                       class="edit-form__select1"
                       placeholder="请选择">
              <el-option
                v-for="(item, index) in timeTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提取时效类型"
                        label-width="0"
                        class="hide-label"
                        prop="extractionAgingType"
                        :rules="formRules.require">
            <!--<el-select v-model="editFormTime.extractionAgingType"
                       size="small"
                       class="edit-form__select1"
                       style="width: 160px;"
                       placeholder="请选择">
              <el-option
                v-for="(item, index) in agingTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>-->
            <el-input value="目的港清关后到门时效"
                      size="small"
                      class=""
                      style="width: 162px;"
                      readonly></el-input>
          </el-form-item>
          <el-form-item label="是否展示提取时效"
                        label-width="0"
                        class="hide-label"
                        prop="extractionAgingIsShow"
                        :rules="formRules.require">
            <el-select v-model="editFormTime.extractionAgingIsShow"
                       size="small"
                       class="edit-form__select1"
                       placeholder="请选择">
              <el-option
                v-for="(item, index) in agingVisibleType"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <br>
        </template>
        <el-form-item :label="deliveryAgingLabel"
                      prop="agingFrom"
                      :rules="formRulesFreightPrice.agingFrom">
          <div class="el-date-editor el-range-editor el-input__inner el-range-editor--small"
               style="width: 160px;">
            <input class="el-range-input input-number__no-arrows"
                   v-model="editFormTime.agingFrom"
                   type="number"
                   placeholder="请输入"
                   autocomplete="off">
            <span class="el-range-separator">至</span>
            <input class="el-range-input input-number__no-arrows"
                   v-model="editFormTime.agingTo"
                   type="number"
                   placeholder="请输入"
                   autocomplete="off">
          </div>
        </el-form-item>
        <el-form-item :label="`${deliveryAgingLabel}单位`"
                      label-width="0"
                      class="hide-label"
                      prop="agingUnit"
                      :rules="formRulesFreightPrice.agingUnit">
          <el-select v-model="editFormTime.agingUnit"
                     size="small"
                     class="edit-form__select1"
                     placeholder="请选择">
            <el-option
              v-for="(item, index) in timeTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="type === 1">
          <el-form-item :label="`${deliveryAgingLabel}类型`"
                        label-width="0"
                        class="hide-label"
                        prop="agingType"
                        :rules="formRules.require">
            <el-select v-model="editFormTime.agingType"
                       size="small"
                       class="edit-form__select1"
                       style="width: 160px;"
                       placeholder="请选择">
              <el-option
                v-for="(item, index) in agingTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--<template v-if="!isSegment">
            <el-form-item :label="`是否展示${deliveryAgingLabel}`"
                          label-width="0"
                          class="hide-label"
                          prop="agingIsShow"
                          :rules="formRules.require">
              <el-select v-model="editFormTime.agingIsShow"
                         size="small"
                         class="edit-form__select1"
                         placeholder="请选择">
                <el-option
                  v-for="(item, index) in agingVisibleType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>-->
        </template>
        <br/>
        <el-form-item label=" ">
          <el-button type=""
                     @click="hideSetTime"
                     size="medium">取消</el-button>
          <el-button type="primary"
                     @click="clickSaveTime()"
                     size="medium">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {isArray, isObject} from "my-tools-kit";
import {rulesNotEmpty} from "@/assets/js/formRules";
import CustomPriceColumn
  from "@/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/customPriceColumn";
import {mergeTableSpanMethod} from "@/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/utils";

let headerCellStyle = { background: '#F9F9F9', color: '#141414', 'font-size': '15px', 'font-weight': '500' };
let timeTypeArray = [
  {label:'工作日',value:1},
  {label:'自然日',value:2},
];
export default {
  name: "cityCustomQuotationList",
  components: {CustomPriceColumn},
  props:{
    isSegment:Boolean,//是否是分段报价
    type:{ // 分段类型 1：全包(头程) 2:派送
      type:Number,
      default:1,
    },
    list:{
      type:Array,
      required:true,
      default:()=>[],
    },
    tableHeaderList:{
      type:Array,
      default:()=>[],
    },
    openCustom:Boolean,
    loadingStatus:Boolean,
    disabledEdit:Boolean,
    openSetFreeDelivery:Boolean,//开放"设为免派区域"
    isSupportMultiChannel:Boolean,//是否多渠道
    // 是否显示按最小分区设置转换比
    isShowRatioSetting: false,
    copyVipPrice: Boolean
  },
  data(){
    let rulesExtractionAgingFrom= (rule, value, callback)=>{
      let start = value;
      if([0,'0'].includes(start)) return callback(new Error('最短提取时效 不能 = 0'));
      start = parseFloat(start);
      if(start<0) return callback(new Error('最短提取时效 不能 < 0'));
      let end = this.editFormTime.extractionAgingTo;
      if([0,'0'].includes(end)) return callback(new Error('最长提取时效 不能 = 0'));
      end = parseFloat(end);
      if(end<0) return callback(new Error('最长提取时效 不能 < 0'));
      if(start > end) return callback(new Error('最短提取时效 > 最长提取时效'))
      return callback();
    };
    let rulesAgingFrom = (rule, value, callback)=>{
      let agingLabel = this.deliveryAgingLabel;
      let start = value;
      if([0,'0'].includes(start)) return callback(new Error(`最短${agingLabel} 不能 = 0`));
      start = parseFloat(start);
      if(start<0) return callback(new Error(`最短${agingLabel} 不能 < 0`));
      let end = this.editFormTime.agingTo;
      if([0,'0'].includes(end)) return callback(new Error(`最长${agingLabel} 不能 = 0`));
      end = parseFloat(end);
      if(end<0) return callback(new Error(`最长${agingLabel} 不能 < 0`));
      if(start > end) return callback(new Error(`最短${agingLabel} > 最长${agingLabel}`))
      return callback();
    };
    return {
      price1:0,
      headerCellStyle,
      /* 分页参数 */
      pageSizes: [10,20,30,40,50],
      pageSize: 10,
      currentPage: 1,

      /* 表单校验 */
      formRules: {
        no: [{trigger: 'blur', required: false}],
        require: [rulesNotEmpty()],
      },
      /*弹窗：设置时间*/
      timeTypeList:timeTypeArray,
      visibleSetTime:false,
      editFormTimeIndex:0,
      editFormTime:{},
      formRulesFreightPrice: {
        extractionAgingFrom:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:rulesExtractionAgingFrom}
        ],
        agingFrom:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:rulesAgingFrom}
        ],
        price:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:(rule, value, callback)=>{
              let start = value;
              if([0,'0'].includes(start)) return callback(new Error('不能=0'));
              start = parseFloat(start);
              if(start<0) return callback(new Error('不能<0'));
              return callback();
            }
          }
        ],
        agingUnit:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:(rule, value, callback)=>{
              let start = value;
              if([0,'0'].includes(start)) return callback(new Error('不能为空'));
              return callback();
            }
          }
        ],
      },
      // 提取时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
      agingTypeList:[
        {label:"开船后开始计算时效",value:1,},
        {label:"入仓后开始计算时效",value:2,},
      ],
      // 是否展示提取时效 boolean
      agingVisibleType:[
        {label:"显示",value:1,},
        {label:"隐藏",value:0,},
      ],
    }
  },
  computed:{
    isDeliveryType(){
      return this.type === 2
    },
    pagingList(){
      let list = this.list;
      if(!isArray(list) || !list.length) return [];
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      return list.slice(start,end);
    },
    totalListNum(){
      let list = this.list||[];
      return list.length
    },
    deliveryAgingLabel(){
      return this.type === 2 ? "派送时效" : "整体时效";
    },
  },
  watch:{
    list(){
      this.handleCurrentChange();
    },
  },
  methods:{
    /**
     * 改变派送报价
     * @param value 当前值
     * @param key   改变值的key
     * @param item  对象
     * @param index 在自定义报价列表中的索引
     * @param regionIndex 改变的区间 0-3（对应区间1-4）
     */
    changeDeliveryInputNumber(value,index,key,item,regionIndex){
      let realListIndex = this.list.findIndex(res=>res.warehouseName === item.warehouseName);
      this.$emit("change",value,key,item,realListIndex,regionIndex)
    },
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
    },
    /**
     * 拼接文本
     * @param item  tableHeaderList Item
     * @param index
     * @returns {string}
     */
    joinLabelText(item = {},index){
      if(!isObject(item)) return "";
      let chargeType = item.chargeType||"";
      if(chargeType.toUpperCase() === "BOX") chargeType = "箱";
      else if(chargeType.toUpperCase() === "PK") chargeType = "车";
      let str = ""
      if(item.end){
        str = `${item.start}-${item.end}${chargeType}`
      }else{
        str = `${item.start}${chargeType}以上`
      }
      if(item.supportRenewal){
        if(index === 0){
          str = "首重" + str;
        }else if(index === 1){
          str = "续重" + str;
        }
      }
      return str;
    },
    /**
     * 弹窗:设置时效
     */
    showSetTime(index,row) {
      this.editFormTimeIndex = index;
      function getIsShow(value){
        if(typeof value !== "boolean") value = true; // 默认值 true
        return value;
      }
      this.editFormTime = {
        // 整体/派送时效
        agingFrom:row.agingFrom,// 最短时间
        agingTo:row.agingTo, // 最长时间
        agingUnit:row.agingUnit||1, //时效单位 1：工作日 2：自然日
        agingType:row.agingType || 1, // 时效类型，1：开船后开始计算时效；2：入仓后开始计算时效
        agingIsShow:getIsShow(row.agingIsShow) ? 1 : 0, // 是否展示时效

        // 提取时效
        extractionAgingFrom:row.extractionAgingFrom,
        extractionAgingTo:row.extractionAgingTo,
        extractionAgingUnit:row.extractionAgingUnit||1,
        extractionAgingType:row.extractionAgingType || 1,
        extractionAgingIsShow:getIsShow(row.extractionAgingIsShow) ? 1 : 0,
      };
      this.visibleSetTime = true;
    },
    hideSetTime() {
      this.visibleSetTime = false;
    },
    /**
     * 保存设置时效
     */
    clickSaveTime(formName = 'editSetTime'){
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.error('表单异常');
          return false;
          // let form = this.$refs[formName];
          // let results = getElFormValidateValue(form);
          // return notifyFormValidateErrorInfo.call(this,results);
        }
        if(!this.isSegment){
          if(this.editFormTime.extractionAgingIsShow === 0 && this.editFormTime.agingIsShow === 0){
            this.$message.error("提取时效 和 整体时效 不能全部被隐藏");
            return false;
          }
        }
        let data = Object.assign({},this.editFormTime);
        let keys = Object.keys(data);
        let target = this.pagingList[this.editFormTimeIndex];
        data.agingIsShow = data.agingIsShow === 1;// 整体/派送 时效
        data.extractionAgingIsShow = data.extractionAgingIsShow === 1;//提取时效
        keys.forEach(key=> target[key] = data[key]);
        this.$emit("changeAging",data,target);
        this.hideSetTime();
      });
    },
    /**
     * 合并行或列的计算方法
     */
    spanMethod:mergeTableSpanMethod,
    /**
     * 设为/取消 免派区域
     */
    setFreeDelivery(row,value = 1){
      if(value === 2){ //免派
        row.exemptionType = value;
        row.priceList.forEach( item=> item.price = 0);
        // this.$confirm('设置免派区域，是否确认?', '确认操作', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // })
        //   .then(() => {
        //     row.exemptionType = value;
        //     row.priceList.forEach( item=> item.price = 0);
        //   })
      }else{
        row.exemptionType = value;
        row.priceList.forEach( item=> item.price = "");
      }
    },
    /**
     * 修改报价input
     */
    changePriceInput(value,row){
      if(this.openSetFreeDelivery){
        if([0,"0"].includes(value)){
          let priceList = row.priceList || [];
          let result = priceList.every(item => [0,"0"].includes(item.price));
          // 改分区行所有报价都 = 0 时，自动标识为免派区域
          if(result) row.exemptionType = 2;
        }
      }
    },

    /**
     * 拼接可走货物类型文本
     * @param list
     * @returns {string}
     */
    joinGoodsTypeText(list = []){
      return list.map(item=>item.goodsTypeName).join(",");
    },
    joinCityNameText(list = []){
      return list.map(item=>item.cityName).join(",");
    },
  },
}
</script>

<style scoped lang="scss">
.custom-delivery-table{
  &.el-table /deep/ {
    td{
      position: relative;
      //padding: 0;
      .cell {
        text-align: center;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #141414;
        .el-input__inner {
          border: none;
          font-size: 15px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #141414;
          text-align: center;
          &::placeholder {
            color: #999;
          }
        }
      }
    }
  }
  /deep/ .custom-input-number{
    width: 100px;
    .custom-input-number__decrease,
    .custom-input-number__increase{
      width: 18px;
    }
    .custom-input-number__decrease{}
    .custom-input-number__increase{}
    .el-input__inner{
      padding-left: 20px ;
      padding-right: 20px ;
    }
  }
  .unit{
    font-size: 12px;
    color: #999;
  }
  .error-hint{
    color: red;
    font-size: 12px;
    line-height: 1;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }
  .is-private-address{
    font-size: 12px;
    color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/index.vue